import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { CommonProperties } from '../styles';

const BaseText = (props) => {
  const incomingStyle = Array.isArray(props.style) ? props.style : [props.style];
  const incomingNumberOfLines = props.numberOfLines ? props.numberOfLines : 0;
  return (
    <Text
      {...props}
      numberOfLines={incomingNumberOfLines}
      style={[styles.defaultTextStyle, ...incomingStyle]}
    />
  );
};

const styles = StyleSheet.create({
  defaultTextStyle: {
    ...CommonProperties.body,
    ...CommonProperties.fontFamily,
  },
});

export default BaseText;
